import React, { useState, useEffect } from 'react'
import HeaderHome from '../../components/headerHome/HeaderHome';
import './Login.css'
import { useNavigate, Link } from 'react-router-dom'
import { ContentBodyLogiInterno } from '../../components/login/ContentBodyLogiInterno'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'

export const Login = () =>{
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false);
    }
  }
  const navigate = useNavigate();
  const olvidarContraseña = () => {
    navigate('/recuperarContraseña');
  }
  //<div onClick={navegar}>Si no itiene cuenta, <b>regístrese aquí.</b></div>
  return (
    <div className='Login' onClick={closeMenu}>
      <div className='headerLogin'> <HeaderHome /> </div>
      <div className='bodyLogin'>
        <div className='justify-center items-center flex flex-col w-full h-full'>
          <ContentBodyLogiInterno
            olvidarContraseña={olvidarContraseña}
            />
        </div>

        <div className='footerLogin'> <MiFooter /> </div>
      </div>
    </div>
  )
}

export default Login;
